<template>
  <v-card :loading="loading" :disabled="loading">
    <v-toolbar flat>
      <v-icon left color="accent">mdi-golf-cart</v-icon>
      <v-toolbar-title>Wedges</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        outlined
        @click="openForm()"
        :disabled="!isModifiable"
      >
        <v-icon>mdi-plus</v-icon>Add Single Wedge
      </v-btn>
    </v-toolbar>
    <PrescriptionItems
      :headers="headers"
      :items="items"
      :isModifiable="isModifiable"
      @update="update()"
      @edit="(item) => openForm(item)"
    />
    <wedge-form
      ref="wedgeForm"
      :prescriptionId="prescriptionId"
      :dominantHand="dominantHand"
      :currency="prescription.currency.currency"
      :catalogId="this.catalogId"
      @update="update()"
    ></wedge-form>
  </v-card>
</template>

<script>
import PrescriptionItems from './PrescriptionItems.vue';
import WedgeForm from "./WedgeForm";

export default {
  components: {
    WedgeForm,
    PrescriptionItems
},
  props: ["wedges", "prescriptionId", "dominantHand", "shopId",'catalogId', "prescription"],
  data: function() {
    return {
      items: this.wedges,
      itemToEdit: null,
      formEdit: false,
      formType: "solo",
      headers: [
        { text: "Quote", value: "quote", sortable: false },
        { text: "Quantity", value: "quantity" },
        { text: "SST Pure", value: "sst", sortable: false },
        { text: "Stamping", value: "stamping", sortable: false },
        { text: "Paintfill", value: "paintfill", sortable: false },
        { text: "Head", value: "head" },
        { text: "Shaft", value: "shaft" },
        { text: "Grip", value: "grip" },
        { text: "Actions", value: "actions"},
      ],
      loading: false
    };
  },
  computed : {
    isModifiable () {
      return this.prescription.isModifiable
    }
  },
  methods: {
    getList() {
      this.loading = true
      this.$store
        .dispatch("prescriptionWedge/get", {
          id: this.prescriptionId
        })
        .then(datas => (this.items = datas))
        .finally(() => {this.loading = false});
    },
    update() {
      this.getList();
      this.$emit("update");
    },
    openForm(item) {
      this.$refs.wedgeForm.open(item)
    }
  }
};
</script>

<style></style>
